//Try to use alphabetic order
import { AppUpdateComponent } from "src/app/pages/app-update/app-update.component";
import { AppRestrictedComponent } from "src/app/pages/app-restricted/app-restricted.component";
import { DepositMainComponent } from "src/app/pages/cashier/deposit/deposit-main/deposit-main.component";
import { ForgotPasswordComponent } from "src/app/pages/forgot-password/forgot-password.component";
import { GeoComplyComponent } from "src/app/pages/geo-comply/geo-comply.component";
import { LoginComponent } from "src/app/pages/login/login.component";
import { CloseAccountComponent } from "src/app/pages/close-account/close-account.component";
import { PlayerProtectionComponent } from "src/app/pages/responsible-gaming/player-protection/player-protection.component";
import { SignupStepOneComponent } from "src/app/pages/signup-step-one/signup-step-one.component";
import { SignupStepTwoComponent } from "src/app/pages/signup-step-two/signup-step-two.component";
import { IdologyKbaComponent } from "src/app/pages/idology-kba/idology-kba.component";
import { UpdatePhoneNumberComponent } from "src/app/pages/update-phone-number/update-phone-number.component";
import { DepositCageComponent } from "src/app/pages/cashier/deposit/deposit-cage/deposit-cage.component";
import { SetDepositLimitsComponent } from "src/app/pages/limits/set-deposit-limits/set-deposit-limits.component";
import { DepositCreditcardComponent } from "src/app/pages/cashier/deposit/deposit-creditcard/deposit-creditcard.component";
import { DepositPlayplusComponent } from "src/app/pages/cashier/deposit/deposit-playplus/deposit-playplus.component";
import { DepositPaynearmeComponent } from "src/app/pages/cashier/deposit/deposit-paynearme/deposit-paynearme.component";
import { DepositPaypalComponent } from "src/app/pages/cashier/deposit/deposit-paypal/deposit-paypal.component";
import { DepositVipComponent } from "src/app/pages/cashier/deposit/deposit-vip/deposit-vip.component";
import { DepositPaywithmybankComponent } from "src/app/pages/cashier/deposit/deposit-paywithmybank/deposit-paywithmybank.component";
import { DepositSuccessFailureComponent } from "src/app/pages/cashier/deposit/deposit-success-failure/deposit-success-failure.component";
import { AccountInformationComponent } from "src/app/pages/information-and-security/account-information/account-information.component";
import { PersonalInformationComponent } from "src/app/pages/information-and-security/personal-information/personal-information.component";
import { UploadDocumentComponent } from "src/app/pages/information-and-security/upload-document/upload-document.component";
import { ChangePasswordComponent } from "src/app/pages/information-and-security/change-password/change-password.component";
import { SecurityQuestionComponent } from "src/app/pages/information-and-security/security-question/security-question.component";
import { ResendPinComponent } from "src/app/pages/information-and-security/resend-pin/resend-pin.component";
import { SetTimeLimitsComponent } from "src/app/pages/limits/set-time-limits/set-time-limits.component";
import { AccountBalanceComponent } from "src/app/pages/account-balance/account-balance.component";
import { GameDetailsComponent } from "src/app/pages/game-details/game-details.component";
import { SetLossLimitsComponent } from "src/app/pages/limits/set-loss-limits/set-loss-limits.component";
import { RafOverviewComponent } from "src/app/pages/refer-a-friend/raf-overview/raf-overview.component";
import { RafInviteEmailComponent } from "src/app/pages/refer-a-friend/raf-invite-email/raf-invite-email.component";
import { ActiveBonusesComponent } from "src/app/pages/rewards/bonuses/active-bonuses/active-bonuses.component";
import { BonusOffersComponent } from "src/app/pages/rewards/bonuses/bonus-offers/bonus-offers.component";
import { PastBonusesComponent } from "src/app/pages/rewards/bonuses/past-bonuses/past-bonuses.component";
import { SetSingleBetLimitsComponent } from "src/app/pages/limits/set-single-bet-limits/set-single-bet-limits.component";
import { WithdrawalPaypalComponent } from "src/app/pages/cashier/withdraw/withdrawal-paypal/withdrawal-paypal.component";
import { WithdrawalVipComponent } from "src/app/pages/cashier/withdraw/withdrawal-vip/withdrawal-vip.component";
import { WithdrawalPrepaidComponent } from "src/app/pages/cashier/withdraw/withdrawal-prepaid/withdrawal-prepaid.component";
import { WithdrawalCageComponent } from "src/app/pages/cashier/withdraw/withdrawal-cage/withdrawal-cage.component";
import { WithdrawalReverseComponent } from "src/app/pages/cashier/withdraw/withdrawal-reverse/withdrawal-reverse.component";
import { TransactionHistoryComponent } from "src/app/pages/cashier/transaction-history/transaction-history.component";
import { LimitsHistoryComponent } from "src/app/pages/limits/limits-history/limits-history.component";
import { CoolOffComponent } from "src/app/pages/cool-off/cool-off.component";
import { BonusDetailsComponent } from "src/app/pages/rewards/bonuses/bonus-details/bonus-details.component";
import { StrongAuthenticationComponent } from "src/app/pages/information-and-security/strong-authentication/strong-authentication.component";
import { AccountSummaryComponent } from "src/app/pages/account-summary/account-summary.component";

import { GameSettingsComponent } from "src/app/pages/information-and-security/game-settings/game-settings.component";
import { WithdrawalReverseConfirmComponent } from "src/app/pages/cashier/withdraw/withdrawal-reverse-confirm/withdrawal-reverse-confirm.component";
import { RedeemBonusCodeComponent } from "src/app/pages/rewards/bonuses/redeem-bonus-code/redeem-bonus-code.component";
import { RiskFreeBetRiskComponent } from "src/app/pages/rewards/bonuses/risk-free-bet-risk/risk-free-bet-risk.component";
import { LoyaltyProgramProvider } from "src/app/services/loyalty-program/loyalty-program.service";
import { TotalDepositsComponent } from "src/app/pages/cashier/overview/total-deposits/total-deposits.component";
import { RejectedWithdrawalsComponent } from "src/app/pages/cashier/overview/rejected-withdrawals/rejected-withdrawals.component";
import { PendingWithdrawalsComponent } from "src/app/pages/cashier/overview/pending-withdrawals/pending-withdrawals.component";
import { TotalWithdrawalsComponent } from "src/app/pages/cashier/overview/total-withdrawals/total-withdrawals.component";
import { WithdrawalMailComponent } from "src/app/pages/cashier/withdraw/withdrawal-mail/withdrawal-mail.component";
import { TaxReportsComponent } from "src/app/pages/tax-reports/tax-reports.component";
import { WinLossComponent } from "src/app/pages/cashier/win-loss/win-loss.component";
import { MyFreeSpinComponent } from "src/app/pages/rewards/bonuses/my-free-spin/my-free-spin.component";
import { SelfExcludeComponent } from "src/app/pages/self-exclude/self-exclude.component";
import { DailySlotComponent } from "src/app/pages/daily-slot/daily-slot.component";
import { GameTransactionsComponent } from "src/app/pages/game-transactions/game-transactions.component";
import { DepositThresholdComponent } from "src/app/pages/cashier/deposit/deposit-threshold/deposit-threshold.component";
import { WithdrawalPayWithMyBankComponent } from "src/app/pages/cashier/withdraw/withdrawal-pay-with-my-bank/withdrawal-pay-with-my-bank.component";
import { GameHistoryComponent } from "src/app/pages/game-history/game-history.component";
import { DeleteAccountComponent } from "src/app/pages/delete-account/delete-account.component";
import { SmsLoginComponent } from "src/app/pages/sms-login/sms-login.component";
import { InvalidKycComponent } from "src/app/pages/invalid-kyc/invalid-kyc.component";
import { CamsComponent } from "src/app/pages/cams/cams.component";
import { IdNowComponent } from "src/app/pages/id-now/id-now.component";
import { SignupResultComponent } from "src/app/pages/signup-result/signup-result.component";
import { ManageNotificationsComponent } from "src/app/pages/information-and-security/manage-notifications/manage-notifications.component";
import { SpendLimitComponent } from "src/app/pages/limits/spend-limit/spend-limit.component";
import { LimitConfirmationComponent } from "src/app/pages/limits/limit-confirmation/limit-confirmation.component";
import { MyTransactionMethodsComponent } from "src/app/pages/my-transaction-methods/my-transaction-methods.component";

import { DepositPayWithCashComponent } from "src/app/pages/cashier/deposit/deposit-pay-with-cash/deposit-pay-with-cash.component";
import { UpdateTocComponent } from "src/app/pages/update-toc/update-toc.component";
import { UpdatePrivacyPolicyComponent } from "src/app/pages/update-privacy-policy/update-privacy-policy.component";
import { UpdateHouseRulesComponent } from "src/app/pages/update-house-rules/update-house-rules.component";
import { ResetPasswordComponent } from "src/app/pages/reset-password/reset-password.component";
import { DepositPlayplusActionComponent } from "src/app/pages/cashier/deposit/deposit-playplus/deposit-playplus-action.component";
import { CoolingOffComponent } from "src/app/pages/cooling-off/cooling-off.component"; import { ResetPasswordVerifyFirstStepComponent } from "src/app/pages/reset-password/reset-password-verify-first-step/reset-password-verify-first-step.component";
import { ResetPasswordVerifySecondStepComponent } from "src/app/pages/reset-password/reset-password-verify-second-step/reset-password-verify-second-step.component";
import { ResetPasswordVerifyThirdStepComponent } from "src/app/pages/reset-password/reset-password-verify-third-step/reset-password-verify-third-step.component";
import { ExternalLinkContentComponent } from "src/app/pages/external-link-content/external-link-content.component";
import { PasswordResetComponent } from "src/app/pages/password-reset/password-reset.component";
import { WithdrawalVenmoComponent } from "src/app/pages/cashier/withdraw/withdrawal-venmo/withdrawal-venmo.component";
import { PlayerMigrationComponent } from "src/app/pages/player-migration/player-migration.component";
import { PlayerMigrationActionComponent } from "src/app/pages/player-migration/player-migration-action.component";
import { DepositWireComponent } from "src/app/pages/cashier/deposit/deposit-wire/deposit-wire.component";
import { ContentPlaceholderComponent } from "src/app/pages/content-placeholder/content-placeholder.component";
import { DepositInstaDebitActionPage } from "src/app/pages/cashier/deposit/deposit-instadebit-action/deposit-instadebit-action";
import { DepositInstaDebitPage } from "src/app/pages/cashier/deposit/deposit-instadebit/deposit-instadebit";
import { DepositIDebitPage } from "src/app/pages/cashier/deposit/deposit-idebit/deposit-idebit";
import { DepositIdebitActionPage } from "src/app/pages/cashier/deposit/deposit-idebit-action/deposit-idebit-action";
import { DepositECheckPage } from "src/app/pages/cashier/deposit/deposit-e-check/deposit-e-check";
import { DepositECheckAddPage } from "src/app/pages/cashier/deposit/deposit-e-check-add/deposit-e-check-add";
import { DepositECheckBasePage } from "src/app/pages/cashier/deposit/deposit-e-check-base/deposit-e-check-base";
import { DepositNeosurfComponent } from "src/app/pages/cashier/deposit/deposit-neosurf/deposit-neosurf.component";
import { DepositGigadetInteracPage } from "src/app/pages/cashier/deposit/deposit-interac/deposit-interac";
import { DepositInteracActionPage } from "src/app/pages/cashier/deposit/deposit-interac-action/deposit-interac-action";
import { WithdrawalECheckAddPage } from "src/app/pages/cashier/withdraw/withdrawal-echeck-add/withdrawal-echeck-add";
import { WithdrawalECheckPage } from "src/app/pages/cashier/withdraw/withdrawal-echeck/withdrawal-echeck";
import { WithdrawalIDebitPage } from "src/app/pages/cashier/withdraw/withdrawal-idebit/withdrawal-idebit";
import { WithdrawalInstaDebitPage } from "src/app/pages/cashier/withdraw/withdrawal-instadebit/withdrawal-instadebit";
import { WithdrawalInteracComponent } from "src/app/pages/cashier/withdraw/withdrawal-interac/withdrawal-interac";
import { WithdrawalInteracAddPage } from "src/app/pages/cashier/withdraw/withdrawal-interac-add/withdrawal-interac-add";
import { PinLoginComponent } from "src/app/pages/login/pin-login/pin-login";
import { DepositNeosurfActionComponent } from "src/app/pages/cashier/deposit/deposit-neosurf/deposit-neosurf-action.component";
import { ResetPasswordMFAComponent } from "src/app/pages/reset-password/reset-password-mfa/reset-password-mfa.component";
import { WithdrawalFastAccessComponent } from "src/app/pages/cashier/withdraw/withdrawal-fastaccess/withdrawal-fastaccess";
import { ResetPasswordMFASecondStepComponent } from "src/app/pages/reset-password/reset-password-mfa-second-step/reset-password-mfa-second-step.component";
import { ChangePasswordMFAComponent } from "src/app/pages/information-and-security/change-password/change-password-mfa/change-password-mfa.component";
import { ChangePasswordMFAStepTwoComponent } from "src/app/pages/information-and-security/change-password/change-password-mfa-step-two/change-password-mfa-step-two.component";
import { LocationWarningComponent } from "src/app/pages/location-warning/location-warning.component";
import { DepositInstantBankTransferPage } from "src/app/pages/cashier/deposit/deposit-instant-bank-transfer/deposit-instant-bank-transfer";
import { WithdrawalInstantBankTransferPage } from "src/app/pages/cashier/withdraw/withdrawal-instant-bank-transfer/withdrawal-instant-bank-transfer";
import { PlayerEligibilityDialogBoxComponent } from "src/app/pages/player-eligibility-dialog-box/player-eligibility-dialog-box.component";
import { ResetPasswordMFAEmailComponent } from "src/app/pages/reset-password/reset-password-mfa-email/reset-password-mfa-email.component";
import { RedeemReffererCodeComponent } from "src/app/pages/redeem-refferer-code/redeem-refferer-code.component";
import { LoyaltyProgramPage } from "src/app/pages/loyalty-program/loyalty-program";
import { TabLandingPage } from "src/app/tabs/tab-landing/tab-landing.page";


//Factory for Modals
// DepositCageModule,
// DepositCreditcardModule,
// DepositMainModule,
// DepositPaypalModule,
// DepositPrepaidModule,
// DepositVenmoModule,
// DepositVipModule,

//when adding new componenet to classFactory object please add to routeFactory object as well with URL friendly name
//Also, please add the URL friendly route path in the app.module.ts
const classFactory: Object = {
  AccountBalanceComponent: AccountBalanceComponent,
  GameDetailsComponent: GameDetailsComponent,
  AccountInformationComponent: AccountInformationComponent,
  ActiveBonusesComponent: ActiveBonusesComponent,
  BonusDetailsComponent: BonusDetailsComponent,
  AppUpdateComponent: AppUpdateComponent,
  AppRestrictedComponent: AppRestrictedComponent,
  BonusOffersComponent: BonusOffersComponent,
  ContentPlaceholderComponent: ContentPlaceholderComponent,
  DailySlotComponent: DailySlotComponent,
  DepositCageComponent: DepositCageComponent,
  DepositCreditcardComponent: DepositCreditcardComponent,
  DepositMainComponent: DepositMainComponent,
  DepositPaynearmeComponent: DepositPaynearmeComponent,
  DepositPaypalComponent: DepositPaypalComponent,
  DepositPlayplusComponent: DepositPlayplusComponent,
  DepositPlayplusActionComponent: DepositPlayplusActionComponent,
  DepositPaywithmybankComponent: DepositPaywithmybankComponent,
  DepositGigadetInteracPage: DepositGigadetInteracPage,
  DepositInteracActionPage: DepositInteracActionPage,
  DepositInstaDebitPage: DepositInstaDebitPage,
  DepositInstaDebitActionPage: DepositInstaDebitActionPage,
  DepositInstantBankTransferPage: DepositInstantBankTransferPage,
  DepositECheckPage: DepositECheckPage,
  DepositECheckAddPage: DepositECheckAddPage,
  DepositECheckBasePage: DepositECheckBasePage,
  DepositIdebitActionPage: DepositIdebitActionPage,
  DepositIDebitPage: DepositIDebitPage,
  DepositVipComponent: DepositVipComponent,
  DepositSuccessFailureComponent: DepositSuccessFailureComponent,
  DepositNeosurfComponent: DepositNeosurfComponent,
  DepositNeosurfActionComponent: DepositNeosurfActionComponent,
  DepositThresholdComponent: DepositThresholdComponent,
  DepositWireComponent: DepositWireComponent,
  GeoComplyComponent: GeoComplyComponent,
  ForgotPasswordComponent: ForgotPasswordComponent,
  LoginComponent: LoginComponent,
  MyFreeSpinComponent: MyFreeSpinComponent,
  PlayerProtectionComponent: PlayerProtectionComponent,
  PastBonusesComponent: PastBonusesComponent,
  RedeemBonusCodeComponent: RedeemBonusCodeComponent,
  RiskFreeBetRiskComponent: RiskFreeBetRiskComponent,
  SignupStepOneComponent: SignupStepOneComponent,
  SignupStepTwoComponent: SignupStepTwoComponent,
  CloseAccountComponent: CloseAccountComponent,
  PersonalInformationComponent: PersonalInformationComponent,
  UploadDocumentComponent: UploadDocumentComponent,
  ChangePasswordComponent: ChangePasswordComponent,
  ChangePasswordMFAComponent: ChangePasswordMFAComponent,
  ResetPasswordMFAEmailComponent: ResetPasswordMFAEmailComponent,
  ChangePasswordMFAStepTwoComponent: ChangePasswordMFAStepTwoComponent,
  SetDepositLimitsComponent: SetDepositLimitsComponent,
  ResendPinComponent: ResendPinComponent,
  SecurityQuestionComponent: SecurityQuestionComponent,
  PendingWithdrawalsComponent: PendingWithdrawalsComponent,
  RafOverviewComponent: RafOverviewComponent,
  RafInviteEmailComponent: RafInviteEmailComponent,
  RejectedWithdrawalsComponent: RejectedWithdrawalsComponent,
  SetTimeLimitsComponent: SetTimeLimitsComponent,
  SetLossLimitsComponent: SetLossLimitsComponent,
  SetSingleBetLimitsComponent: SetSingleBetLimitsComponent,
  LimitConfirmationComponent: LimitConfirmationComponent,
  TaxReportsComponent: TaxReportsComponent,
  TotalDepositsComponent: TotalDepositsComponent,
  TotalWithdrawalsComponent: TotalWithdrawalsComponent,
  WithdrawalPaypalComponent: WithdrawalPaypalComponent,
  WithdrawalFastAccessComponent: WithdrawalFastAccessComponent,
  WithdrawalVipComponent: WithdrawalVipComponent,
  WithdrawalPrepaidComponent: WithdrawalPrepaidComponent,
  WithdrawalCageComponent: WithdrawalCageComponent,
  WithdrawalReverseComponent: WithdrawalReverseComponent,
  WithdrawalReverseConfirmComponent: WithdrawalReverseConfirmComponent,
  WithdrawalPayWithMyBankComponent: WithdrawalPayWithMyBankComponent,
  TransactionHistoryComponent: TransactionHistoryComponent,
  LimitsHistoryComponent: LimitsHistoryComponent,
  StrongAuthenticationComponent: StrongAuthenticationComponent,
  GameSettingsComponent: GameSettingsComponent,
  WithdrawalMailComponent: WithdrawalMailComponent,
  WinLossComponent: WinLossComponent,
  CoolOffComponent: CoolOffComponent,
  AccountSummaryComponent: AccountSummaryComponent,
  SelfExcludeComponent: SelfExcludeComponent,
  LoyaltyProgramPage: LoyaltyProgramPage,
  GameTransactionsComponent: GameTransactionsComponent,
  IdologyKbaComponent: IdologyKbaComponent,
  InvalidKycComponent: InvalidKycComponent,
  CamsComponent: CamsComponent,
  IdNowComponent: IdNowComponent,
  SignupResultComponent: SignupResultComponent,
  UpdatePhoneNumberComponent: UpdatePhoneNumberComponent,
  GameHistoryComponent: GameHistoryComponent,
  DeleteAccountComponent: DeleteAccountComponent,
  SmsLoginComponent: SmsLoginComponent,
  ManageNotificationsComponent: ManageNotificationsComponent,
  SpendLimitComponent: SpendLimitComponent,
  MyTransactionMethodsComponent: MyTransactionMethodsComponent,
  DepositPayWithCashComponent: DepositPayWithCashComponent,
  UpdateTocComponent: UpdateTocComponent,
  UpdatePrivacyPolicyComponent: UpdatePrivacyPolicyComponent,
  PinLoginComponent: PinLoginComponent,
  UpdateHouseRulesComponent: UpdateHouseRulesComponent,
  ResetPasswordComponent: ResetPasswordComponent,
  ResetPasswordMFAComponent: ResetPasswordMFAComponent,
  ResetPasswordMFASecondStepComponent: ResetPasswordMFASecondStepComponent,
  CoolingOffComponent: CoolingOffComponent,
  ResetPasswordVerifyFirstStepComponent: ResetPasswordVerifyFirstStepComponent,
  ResetPasswordVerifySecondStepComponent: ResetPasswordVerifySecondStepComponent,
  ResetPasswordVerifyThirdStepComponent: ResetPasswordVerifyThirdStepComponent,
  ExternalLinkContentComponent: ExternalLinkContentComponent,
  PasswordResetComponent: PasswordResetComponent,
  WithdrawalVenmoComponent: WithdrawalVenmoComponent,
  WithdrawalInstantBankTransferPage: WithdrawalInstantBankTransferPage,
  PlayerMigrationComponent: PlayerMigrationComponent,
  PlayerMigrationActionComponent: PlayerMigrationActionComponent,
  WithdrawalECheckAddPage: WithdrawalECheckAddPage,
  WithdrawalECheckPage: WithdrawalECheckPage,
  WithdrawalIDebitPage: WithdrawalIDebitPage,
  WithdrawalInstaDebitPage: WithdrawalInstaDebitPage,
  WithdrawalInteracComponent: WithdrawalInteracComponent,
  WithdrawalInteracAddPage: WithdrawalInteracAddPage,
  LocationWarningComponent: LocationWarningComponent,
  PlayerEligibilityDialogBoxComponent: PlayerEligibilityDialogBoxComponent,
  RedeemReffererCodeComponent: RedeemReffererCodeComponent,
  LoyaltyProgramProvider: LoyaltyProgramProvider,
  TabLandingPage: TabLandingPage
};

export const stringToClass = (className) => {
  if (className in classFactory) {
    return classFactory[className];
  }
  return console.log("No page class match for " + className);
};

//URL friendly name of component for pageView event.
//Also, please add the URL friendly route path in the app.module.ts
const routeFactory: Object = {
  GameDetailsComponent: 'game-details',
  AccountBalanceComponent: 'account-balance',
  AccountInformationComponent: 'account-information',
  ActiveBonusesComponent: 'active-bonuses',
  BonusDetailsComponent: 'bonus-details',
  AppUpdateComponent: 'app-update',
  AppRestrictedComponent: 'app-restricted',
  BonusOffersComponent: 'bonus-offers',
  ContentPlaceholder: 'content-placeholder',
  DailySlotComponent: 'daily-slot',
  DepositCageComponent: 'deposit-cage',
  LoyaltyProgramPage: 'loyalty-program',
  DepositCreditcardComponent: 'deposit-creditcard',
  DepositMainComponent: 'deposit-main',
  DepositPaynearmeComponent: 'deposit-paynearme',
  DepositPaypalComponent: 'deposit-paypal',
  DepositPlayplusComponent: 'deposit-playplus',
  DepositPlayplusActionComponent: 'deposit-playplus-action',
  DepositPaywithmybankComponent: 'deposit-paywithmybank',
  DepositVenmoComponent: 'deposit-venmo',
  DepositApplepayComponent: 'deposit-applepay',
  DepositVipComponent: 'deposit-vip',
  DepositSuccessFailureComponent: 'deposit-successFailure',
  DepositThresholdComponent: 'deposit-threshold',
  DepositWireComponent: 'deposit-wire',
  GeoComplyComponent: 'geo-comply',
  ForgotPasswordComponent: 'forgot-password',
  LoginComponent: 'login',
  MyFreeSpinComponent: 'my-free-spin',
  PlayerProtectionComponent: 'player-protection',
  PastBonusesComponent: 'past-bonuses',
  RedeemBonusCodeComponent: 'redeem-bonus-code',
  RiskFreeBetRiskComponent: 'risk-free-bet-risk',
  SignupStepOneComponent: 'signup-step-one',
  SignupStepTwoComponent: 'signup-step-two',
  CloseAccountComponent: 'close-account',
  PersonalInformationComponent: 'personal-information',
  PinLoginComponent: 'pin-login',
  UploadDocumentComponent: 'upload-document',
  ChangePasswordComponent: 'change-password',
  ChangePasswordMFAComponent: 'change-password-mfa',
  ResetPasswordMFAEmailComponent: 'reset-password-mfa-email',
  ChangePasswordMFAStepTwoComponent: 'change-password-mfa-step-two',
  SetDepositLimitsComponent: 'set-deposit-limits',
  ResendPinComponent: 'resend-pin',
  TabLandingPage: 'landing-page',
  SecurityQuestionComponent: 'security-question',
  PendingWithdrawalsComponent: 'pending-withdrawals',
  RafOverviewComponent: 'raf-overview',
  RafInviteEmailComponent: 'raf-invite-email',
  RejectedWithdrawalsComponent: 'rejected-withdrawals',
  SetTimeLimitsComponent: 'set-time-limits',
  SetLossLimitsComponent: 'set-loss-limits',
  SetSingleBetLimitsComponent: 'set-single-bet-limits',
  TaxReportsComponent: 'tax-reports',
  TotalDepositsComponent: 'total-deposits',
  TotalWithdrawalsComponent: 'total-withdrawals',
  WithdrawalPaypalComponent: 'withdrawal-paypal',
  WithdrawalFastAccessComponent: 'withdrawal-faf',
  WithdrawalVipComponent: 'withdrawal-vip',
  WithdrawalPrepaidComponent: 'withdrawal-prepaid',
  WithdrawalCageComponent: 'withdrawal-cage',
  WithdrawalReverseComponent: 'withdrawal-reverse',
  WithdrawalReverseConfirmComponent: 'withdrawal-reverse-confirm',
  WithdrawalPayWithMyBankComponent: 'withdrawal-payWithMyBank',
  TransactionHistoryComponent: 'transaction-history',
  LimitsHistoryComponent: 'limits-history',
  StrongAuthenticationComponent: 'strong-authentication',
  GameSettingsComponent: 'game-settings',
  WithdrawalMailComponent: 'withdrawal-mail',
  WinLossComponent: 'win-loss',
  CoolOffComponent: 'cool-off',
  AccountSummaryComponent: 'account-summary',
  SelfExcludeComponent: 'self-exclude',
  GameTransactionsComponent: 'game-transactions',
  IdologyKbaComponent: 'idology-kba',
  InvalidKycComponent: 'invalid-kyc',
  CamsComponent: 'cams',
  IdNowComponent: 'id-now',
  SignupResultComponent: 'signup-result',
  UpdatePhoneNumberComponent: 'update-phonenumber',
  GameHistoryComponent: 'game-history',
  DeleteAccountComponent: 'delete-account',
  SmsLoginComponent: 'sms-login',
  ManageNotificationsComponent: 'manage-notifications',
  SpendLimitComponent: 'spend-limit',
  MyTransactionMethodsComponent: 'my-transaction-methods',
  DepositPayWithCashComponent: 'deposit-pay-with-cash',
  UpdateTocComponent: 'update-toc',
  UpdatePrivacyPolicyComponent: 'update-privacy-policy',
  UpdateHouseRulesComponent: 'update-house-rules',
  ResetPasswordComponent: 'reset-password',
  ResetPasswordMFAComponent: 'reset-password-mfa',
  ResetPasswordMFASecondStepComponent: 'reset-password-mfa-second-step',
  CoolingOffComponent: 'cooling-off',
  ResetPasswordVerifyFirstStepComponent: 'reset-password-verify-first-step',
  ResetPasswordVerifySecondStepComponent: 'reset-password-verify-second-step',
  ResetPasswordVerifyThirdStepComponent: 'reset-password-verify-third-step',
  ExternalLinkContentComponent: 'external-link-content',
  PasswordResetComponent: 'password-reset',
  WithdrawalVenmoComponent: 'withdrawal-venmo',
  PlayerMigrationComponent: 'player-migration',
  PlayerMigrationActionComponent: 'player-migration-action',
  LimitConfirmationComponent: 'limit-adjustment-confirmation',
  LocationWarningComponent: 'location-warning',
  PlayerEligibilityDialogBoxComponent: 'player-eligibility-dialog',
  RedeemReffererCodeComponent: 'redeem-refferer-code',
  WithdrawalInteracComponent: 'withdrawal-interac'

};

export const checkRoutesName = (routeName) => {
  if (routeName in classFactory) {
    return routeFactory[routeName];
  }
  return console.log("No page class match for " + routeName);
};

//Reverse the Route check to accomodate browser Back/forward button
//Creating 2 seprate objects for LoggedIn and LoggedOut path which can be route based on user authentication.
const redirectLoggedInRouteFactory: Object = {
  "accountinformation": "AccountInformationComponent",
  "accountbalance": "AccountBalanceComponent",
  "activebonuses": "ActiveBonusesComponent",
  "bonusdetails": "BonusDetailsComponent",
  "appupdate": "AppUpdateComponent",
  "apprestricted": "AppRestrictedComponent",
  "bonusoffers": "BonusOffersComponent",
  "contentplaceholder": "ContentPlaceholderComponent",
  "dailyslot": "DailySlotComponent",
  "depositcage": "DepositCageComponent",
  "depositcreditcard": "DepositCreditcardComponent",
  "depositmain": "DepositMainComponent",
  "depositpaynearme": "DepositPaynearmeComponent",
  "depositpaypal": "DepositPaypalComponent",
  "depositplayplus": "DepositPlayplusComponent",
  "depositplayplusaction": "DepositPlayplusActionComponent",
  "depositpaywithmybank": "DepositPaywithmybankComponent",
  "depositvenmo": "DepositVenmoComponent",
  "depositvip": "DepositVipComponent",
  "depositsuccessfailure": "DepositSuccessFailureComponent",
  "depositthreshold": "DepositThresholdComponent",
  "depositwire": "DepositWireComponent",
  "forgotpassword": "ForgotPasswordComponent",
  "myfreespin": "MyFreeSpinComponent",
  "playerprotection": "PlayerProtectionComponent",
  "pastbonuses": "PastBonusesComponent",
  "redeembonuscode": "RedeemBonusCodeComponent",
  "riskfreebetrisk": "RiskFreeBetRiskComponent",
  "closeaccount": "CloseAccountComponent",
  "personalinformation": "PersonalInformationComponent",
  "uploaddocument": "UploadDocumentComponent",
  "changepassword": "ChangePasswordComponent",
  "changepasswordmfa": "ChangePasswordMFAComponent",
  "resetpaswordmfaemail": "ResetPasswordMFAEmailComponent",
  "changepasswordmfasteptwo": "ChangePasswordMFAStepTwoComponent",
  "setdepositlimits": "SetDepositLimitsComponent",
  "resendpin": "ResendPinComponent",
  "securityquestion": "SecurityQuestionComponent",
  "pendingwithdrawals": "PendingWithdrawalsComponent",
  "rafoverview": "RafOverviewComponent",
  "rafinviteemail": "RafInviteEmailComponent",
  "rejectedwithdrawals": "RejectedWithdrawalsComponent",
  "settimelimits": "SetTimeLimitsComponent",
  "setlosslimits": "SetLossLimitsComponent",
  "setsinglebetlimits": "SetSingleBetLimitsComponent",
  "taxreports": "TaxReportsComponent",
  "totaldeposits": "TotalDepositsComponent",
  "totalwithdrawals": "TotalWithdrawalsComponent",
  "withdrawalpaypal": "WithdrawalPaypalComponent",
  "withdrawalvip": "WithdrawalVipComponent",
  "withdrawalprepaid": "WithdrawalPrepaidComponent",
  "withdrawalcage": "WithdrawalCageComponent",
  "withdrawalreverse": "WithdrawalReverseComponent",
  "withdrawalreverseconfirm": "WithdrawalReverseConfirmComponent",
  "withdrawalfastaccess": "WithdrawalFastAccessComponent",
  "withdrawalpayWithMyBank": "WithdrawalPayWithMyBankComponent",
  "transactionhistory": "TransactionHistoryComponent",
  "limitshistory": "LimitsHistoryComponent",
  "strongauthentication": "StrongAuthenticationComponent",
  "gamesettings": "GameSettingsComponent",
  "withdrawalmail": "WithdrawalMailComponent",
  "winloss": "WinLossComponent",
  "cooloff": "CoolOffComponent",
  "accountsummary": "AccountSummaryComponent",
  "selfexclude": "SelfExcludeComponent",
  "gametransactions": "GameTransactionsComponent",
  "idologykba": "IdologyKbaComponent",
  "invalidkyc": "InvalidKycComponent",
  "cams": "CamsComponent",
  "idnow": "IdNowComponent",
  "signupresult": "SignupResultComponent",
  "updatephonenumber": "UpdatePhoneNumberComponent",
  "gamehistory": "GameHistoryComponent",
  "deleteaccount": "DeleteAccountComponent",
  "managenotifications": "ManageNotificationsComponent",
  "spendlimit": "SpendLimitComponent",
  "gamedetails": "GameDetailsComponent",
  "mytransactionmethods": "MyTransactionMethodsComponent",
  "depositpaywithcash": "DepositPayWithCashComponent",
  "updatetoc": "UpdateTocComponent",
  "updateprivacypolicy": "UpdatePrivacyPolicyComponent",
  "updatehouserules": "UpdateHouseRulesComponent",
  "resetpassword": "ResetPasswordComponent",
  "resetpasswordmfa": "ResetPasswordMFAComponent",
  "coolingoff": "CoolingOffComponent",
  "resetpasswordverifyfirststep": "ResetPasswordVerifyFirstStepComponent",
  "resetpasswordverifysecondstep": "ResetPasswordVerifySecondStepComponent",
  "resetpasswordverifythirdstep": "ResetPasswordVerifyThirdStepComponent",
  "externallinkcontent": "ExternalLinkContentComponent",
  "passwordreset": "PasswordResetComponent",
  "withdrawalvenmo": "WithdrawalVenmoComponent",
  "playermigration": "PlayerMigrationActionComponent",
  "playermigrationaction": "PlayerMigrationActionComponent",
  "limitconfirmation": "LimitConfirmationComponent",
  "redeemrefferercode": "RedeemReffererCodeComponent",
  "loyaltyprogram": "LoyaltyProgramPage",
  "withdrawalinterac": "WithdrawalInteracComponent"
}

export const checkRedirectLoggedInRoutesName = (routeName) => {
  if (routeName in redirectLoggedInRouteFactory) {
    return redirectLoggedInRouteFactory[routeName];
  }
  return console.log("LoggedINRoute " + routeName);
};

//LoggedOut Route - Browser Back/Forward button logic
const redirectLoggedOutRouteFactory: Object = {
  "login": "LoginComponent",
  "signup": "SignupStepOneComponent",
  "join": "SignupStepOneComponent",
  "signupoptions": "SignupStepOneComponent",
  "forgotpassword": "ForgotPasswordComponent",
  "playerprotection": "PlayerProtectionComponent",
  "signupstepone": "SignupStepOneComponent",
  "signupsteptwo": "SignupStepTwoComponent",
}

export const checkRedirectLoggedOutRoutesName = (routeName) => {
  if (routeName in redirectLoggedOutRouteFactory) {
    return redirectLoggedOutRouteFactory[routeName];
  }
  return console.log("LoggedOutRoute " + routeName);
};
